import { UserTasksStore } from './user-tasks.store';
import { Component, inject, input } from '@angular/core';
import { SwitchInputComponent } from '../../../../kit/input/switch-input/switch-input.component';
import { AppFormGroup, changeSignal } from '../../../../../utils/form.utils';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { CardComponent } from '../../../../kit/card/card.component';
import { UserTaskListComponent } from '../user-task-list/user-task-list.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { successCreated } from '../../../../../modules/content/content.error';
import { UserTaskCreateInput } from '@libs/types/src/services/input-type/user/user-task-create.input';
import { createTaskFrag } from './user-tasks.query';
import { Divider } from '@openng/optimus-ui/divider';
import { TranslatePipe } from '@ngx-translate/core';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';

@Component({
    selector: 'app-user-tasks',
    templateUrl: './user-tasks.component.html',
    styleUrl: './user-tasks.component.scss',
    providers: [UserTasksStore],
    imports: [
        SwitchInputComponent,
        CardComponent,
        UserTaskListComponent,
        TextInputComponent,
        ButtonComponent,
        Divider,
        TranslatePipe,
    ],
})
export class UserTasksComponent {

    public readonly store = inject(UserTasksStore);
    protected readonly folderStore = inject(FolderGlobalStore);

    public folderId = input<number | null, any>(null, { transform: v => v ? Number(v) : null });

    protected formFilter = new AppFormGroup({
        showCompleted: fb.control<boolean>(false),
    });

    protected form = new AppFormGroup({
        newTask: fb.control<string | undefined>(undefined),
    });
    protected readonly newTask = changeSignal(this.form.controls.newTask);

    protected async addTask(event: any | null = null) {
        if (isInvalid(this.form)) return;

        await this.store.api.createUserTask(<UserTaskCreateInput>{
            folderId: this.folderId() || null,
            title: this.form.value.newTask || '',
        }, createTaskFrag);

        this.form.reset();

        if (event) {
            event.srcElement.blur();
        }
        successCreated();
    }
}
